import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SurveyHeader } from 'src/app/models/survey-header.model';
import { AuthService } from 'src/app/services/auth.service';
import { DataService } from 'src/app/services/data.service';
import { SurveyService } from 'src/app/services/survey.service';

@Component({
  selector: 'app-survey-list',
  templateUrl: './survey-list.component.html',
  styleUrls: ['./survey-list.component.scss'],
})


export class SurveyListComponent implements OnInit {
  constructor(
    public surveyServ: SurveyService,
    public dataServ: DataService,
    public authServ: AuthService,
    private router: Router) { }

  async ngOnInit() {
    if (!this.authServ.isLogged) {
      this.router.navigateByUrl('/profile');
    }

    try {
      await this.authServ.getMe();
    } catch (error) {

    }


    this.surveyServ.getSurveys();
  }

}
